import { DeckDTO } from '@/generated';

export const getDeckViewers = (deck: DeckDTO) => {
  return [deck.ownerId, ...(deck?.viewerIds ?? [])];
};
